export const CONFIG = {
  title: "EcoludiK",
  version: "v1.2.0",
  defaultLanguage: "fr",
  defaultTheme: "dark",
  defaultLocale: "fr",
  defaultRefreshRate: 15,
  primaryColour: "#70a87b",
  primaryColourRGB: {
    r: 8,
    g: 79,
    b: 106,
  },
  secondaryColour: "#528396",
  Auth0Domain: "ecoludik.eu.auth0.com",
  Auth0ClientId: "NPHAKHZskbRgl5aaDZruduO7OT81uajb",
  Auth0Audience: "https://api.ecoludik.fr/",
  API_URL: "https://api.ecoludik.444.ovh",
  //API_URL: "http://127.0.0.1:8000",
  rowsPerPage: 100,
  screenMeters: [1],
  waterMeters: [3, 5, 6, 7, 8],
  electricityMeters: [2, 4],
  humidityMeters: [38],
  co2Meters: [39],
};
